import React from 'react'

import ReactLogo from './ReactLogo'

import './footer.css'

export default () =>{

    return (
        <footer>
            {/* <img src={ReactLogo} className="react-logo"/> */}
            <ReactLogo/>
        </footer>
    )
}